/** @jsxImportSource @emotion/react */
import { spinnerStyle } from './Spinner.styles';

export interface SpinnerProps {
  /** 지름(px). 기본 24. */
  size?: number;
  /** 접근성 라벨. 기본 '로딩 중'. */
  label?: string;
}

/** 회전 로딩 인디케이터. 데이터 페칭 대기 영역에 활용. */
export function Spinner({ size = 24, label = '로딩 중' }: SpinnerProps) {
  return <span css={spinnerStyle(size)} role="status" aria-label={label} />;
}
